import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  tiposProjeto: [],
  tipoProjetoTiposAtividade: [],
};

const getters = {
  // Tipos Projeto
  tiposProjeto: state => state.tiposProjeto.sort((a,b) => a.Descricao > b.Descricao ? 1 : -1),
  tiposProjetoAtivo: state => state.tiposProjeto.filter(t => t.Status.startsWith('A')).sort((a,b) => a.Descricao > b.Descricao ? 1 : -1),
  tipoProjetoTiposAtividade: state => state.tipoProjetoTiposAtividade.sort((a,b) => a.TipoAtividade > b.TipoAtividade ? 1 : -1),
}

const actions = {
  // Tipos Projetos
  async fetchTiposProjeto({ commit }) {
    const response = await axios.get(`${baseUrl}/tiposprojetos`);
    if (response.data) {
      commit('setTiposProjeto', response.data);
    } else {
      commit('setTiposProjeto', []);
    }
  },
  async fetchTiposProjetoSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/tiposprojetos?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setTiposProjeto', response.data);
      } else {
        commit('setTiposProjeto', []);
      }
    } catch (error) {
      commit('setTiposProjeto', []);
    }
  },
  async addTipoProjeto({ commit }, tipoProjeto) {
    const response = await axios.post(`${baseUrl}/tiposprojetos`, tipoProjeto);
    tipoProjeto.IdTipoProjeto = response.data.IdTipoProjeto;
    commit('newTipoProjeto', tipoProjeto);
    return response.data.IdTipoProjeto;
  },
  async updateTipoProjeto({ commit }, updTipoProjeto) {
    await axios.put(`${baseUrl}/tiposprojetos`, updTipoProjeto);
    commit('updateTipoProjeto', updTipoProjeto);
  },
  async deleteTipoProjeto({ commit }, id) {
    await axios.delete(`${baseUrl}/tiposprojetos/${id}`);
    commit('removeTipoProjeto', id);
  },
  // Tipos Atividade
  resetaTipoProjetoTiposAtividade({ commit }) {
    commit('resetaTipoProjetoTiposAtividade');
  },
  async fetchTipoProjetoTiposAtividade({ commit }, id) {
    try {
      const response = await axios.get(`${baseUrl}/tiposprojetos/${id}/tiposatividade`);
      if (response.data.length) {
        commit('setTipoProjetoTiposAtividade', response.data);
      } else {
        commit('setTipoProjetoTiposAtividade', []);  
      }
    } catch (error) {
      commit('setTipoProjetoTiposAtividade', []);
    }
  },
  async addTipoProjetoTipoAtividade({ commit }, tipoProjetoTipoAtividade) {
    try {
      const response = await axios.post(`${baseUrl}/tiposprojetos/${tipoProjetoTipoAtividade.IdTipoProjeto}/tiposatividade`, tipoProjetoTipoAtividade);
      if (response) {
        commit('newTipoProjetoTipoAtividade', tipoProjetoTipoAtividade);
      }
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async deleteTipoProjetoTipoAtividade({ commit }, tipoProjetoTipoAtividade) {
    await axios.delete(`${baseUrl}/tiposprojetos/${tipoProjetoTipoAtividade.IdTipoProjeto}/tiposatividade/${tipoProjetoTipoAtividade.IdTipoAtividade}`);
    commit('removeTipoProjetoTipoAtividade', tipoProjetoTipoAtividade.IdTipoAtividade);
  },
}

const mutations = {
  // Tipos Projeto
  setTiposProjeto: (state, tiposProjeto) => state.tiposProjeto = tiposProjeto,
  newTipoProjeto: (state, tipoProjeto) => state.tiposProjeto.push(tipoProjeto),
  removeTipoProjeto: (state, id) => state.tiposProjeto = state.tiposProjeto.filter(tipoProjeto => tipoProjeto.IdTipoProjeto !== id),
  updateTipoProjeto: (state, updTipoProjeto) => {
    const index = state.tiposProjeto.findIndex(tipoProjeto => tipoProjeto.IdTipoProjeto === updTipoProjeto.IdTipoProjeto);
    if (index !== -1) {
      state.tiposProjeto.splice(index, 1, updTipoProjeto);
    }
  },
  // Tipos Atividade
  resetaTipoProjetoTiposAtividade: state => state.tipoProjetoTiposAtividade = [],
  setTipoProjetoTiposAtividade: (state, tiposAtividade) => state.tipoProjetoTiposAtividade = tiposAtividade,
  newTipoProjetoTipoAtividade: (state, tipoAtividade) => state.tipoProjetoTiposAtividade.push(tipoAtividade),
  removeTipoProjetoTipoAtividade: (state, id) => state.tipoProjetoTiposAtividade = state.tipoProjetoTiposAtividade.filter(tipoAtividade => tipoAtividade.IdTipoAtividade !== id),
}

export default {
  state,
  getters,
  actions,
  mutations
}